<template>
    <q-slide-item
        :class="{'-canceled' : assignment.canceled}"
        left-color="red" right-color="green"
        @left="onLeft" @right="onRight"
        @slide="sliding($event)"
        ref="js-slider"
        :data-component-name="$options.name"
    >
        <template v-slot:left>
            <div class="slider-icon">
                <div class="column items-center">
                    <q-icon name="thumb_down" class="q-mb-sm" size="16px" />
                    <div>Refuser</div>
                </div>
            </div>
        </template>
        <template v-slot:right>
            <div class="slider-icon">
                <div class="column items-center">
                    <q-icon name="thumb_up" size="16px" />
                    <div>Accepter</div>
                </div>
            </div>
        </template>

        <div class="-checkboxes text-right -hidden-mobile"
        >
        <!-- {{index}}  -->
        <q-checkbox dense size="24px" color="blue"
                :value="selected.includes(assignment.id)"
                @input="$emit('set-selected')"
            />
        </div>
        <div class="-dates"
            @click="$emit('set-selected')"
        >
            {{ date2str(assignment.date).short }} de
            {{ assignment.start_time.split(":")[0] + ':' + assignment.start_time.split(":")[1] }}
            à 
            {{ assignment.end_time.split(":")[0] + ':' + assignment.end_time.split(":")[1] }}
            <span class="-canceled-badge" v-if="assignment.canceled"></span>
            <span class="-maybe-badge" v-else-if="assignment.maybeByUser"></span>
            <span class="-denied-badge" v-else-if="assignment.deniedByUser"></span>
            <span class="-new-badge" v-else></span>
        </div>
        <div class="-dates -hidden-mobile"
            @click="$emit('set-selected')"
        >
            {{ date2str(assignment.date).shortWd }}
            <span class="-canceled-badge" v-if="assignment.canceled"></span>
            <span class="-maybe-badge" v-else-if="assignment.maybeByUser"></span>
            <span class="-denied-badge" v-else-if="assignment.deniedByUser"></span>
            <!-- <span class="-new-badge" v-else></span> -->
        </div>
        <div class="-hours -hidden-mobile"
            @click="$emit('set-selected')"
        >
            {{ assignment.start_time.split(":")[0] + ':' + assignment.start_time.split(":")[1] }}
            à 
            {{ assignment.end_time.split(":")[0] + ':' + assignment.end_time.split(":")[1] }}
        </div>
        <div class="-shifts -hidden-mobile"
            @click="$emit('set-selected')"        
        >
            {{ assignment.projectShift.name }}
        </div>
        <div class="-professions -hidden-desktop full-width o-row"
            @click="$emit('set-selected')"
        >
            <div><span class="label">Métier : </span>{{ assignment.profession.name }}</div>
            <div><span class="label">Quart de travail : </span>{{ assignment.projectShift.name }}</div>
        </div>
        <div class="-professions -hidden-mobile"
            @click="$emit('set-selected')"
        >
            {{ assignment.profession.name }}
        </div>
        <div class="-acceptation -hidden-mobile">
            <AcceptationSelect
                :userProfileID="userProfileID"
                :lastDenyReason="lastDenyReason"
                :outline="true"
                :canceled="assignment.canceled"
                size="9px"
                acceptButton="Accepter"
                denyButton="Refuser"
                @accept-assignment="$emit('accept-assignment', $event)"
                @confirm-cancel="$emit('accept-assignment', {value: 'confirm-cancel', reason: ''})"
                :assignmentError="acceptingAssignments.includes(assignment.id)"
            />
        </div>

        <q-dialog v-model="prompt"
            ref="promptDialog"
        >
            <q-card style="min-width: 350px">
                <q-card-section>
                    <div class="text-h6">Commentaires</div>
                </q-card-section>

                <q-card-section class="q-pt-none">
                    <Input :required='true' type="textarea" autogrow v-model="reason" autofocus @keyup.enter="prompt = false" />
                </q-card-section>

                <q-card-actions align="right" class="text-primary">
                    <q-btn flat label="Annuler" v-close-popup @click.stop="cancelDeny()" />
                    <q-btn flat label="Continuer" @click.stop="confirmDeny()" />
                </q-card-actions>
            </q-card>
        </q-dialog>
    </q-slide-item>
</template>

<script>
    // import { USERASSIGNMENTS } from "@/graphql/assignment/queries";
    // import { ACCEPTNOTIFICATIONASSIGNMENT } from "@/graphql/notification/mutations"
	import AcceptationSelect from "@/components/forms/AcceptationSelect"
    import {date2str} from "@/js/dateUtilities"

    export default {
        name: 'PendingAssignmentSlider',
        components: { 
            AcceptationSelect
        },
        props: {
        	assignment:{
        		type: Object,
        		default: null,
        	},
            selected: {
                type: Array,
                default(){
                    return [];
                }
            },
            acceptingAssignments: {
                type: Array,
                default(){
                    return [];
                }
            },
            index: {
                type: Number,
                default:0
            }
        },
        data(){
        	return {
				lastDenyReason: null,
                userProfileID: window.myUserProfileID,
                prompt: false,
                reason: '',
                reset: null
        	}
        },
        //mounted(){},
        //computed: {},
        //watch: {},
        methods: {
            date2str(date){
                return date2str(date);
            },
            sliding(e){
                if(e.side=='left'){
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__left").style.opacity=e.ratio
                    let translateX=e.ratio*80;
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__content").style.transform='translateX('+translateX+'px)';
                }
                if(e.side=='right'){
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__right").style.opacity=e.ratio
                    let translateX=e.ratio*80;
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__content").style.transform='translateX(-'+translateX+'px)';
                }
            },
            onLeft({ reset }){
                this.reset=reset;
                this.prompt=true;
                return;
                // this.finalize(reset)
            },
            onRight(/*{ reset }*/){
                this.$emit('accept-assignment', {value: 'accept', reason: ''})
                // this.finalize(reset)
            },
            finalize (reset) {
                this.timer = setTimeout(() => {
                    reset()
                }, 100)
            },
            cancelDeny(){
                if(this.reset) this.finalize(this.reset)
            },
            confirmDeny(){
                if(!this.reason || this.reason==""){
                    this.$refs.promptDialog.shake();
                    return false;
                }
                this.$refs.promptDialog.hide();
                this.$emit('accept-assignment', {value: 'deny', reason: this.reason})
            },
        },
    }
</script>